// Shared A–Z helpers for list views.
export const lastName = (name = "") => {
  const parts = String(name).trim().split(/\s+/);
  return parts.length > 1 ? parts[parts.length - 1] : parts[0] || "";
};

const cmp = (a, b) => String(a || "").localeCompare(String(b || ""), "en-GB", { sensitivity: "base" });

// mode: "last" | "first" | "az" | "za"
export const sortByName = (items, getName = (x) => x.name, mode = "az") => {
  const list = [...(items || [])];
  if (mode === "default") return list;
  if (mode === "last") return list.sort((a, b) => cmp(lastName(getName(a)), lastName(getName(b))) || cmp(getName(a), getName(b)));
  if (mode === "za") return list.sort((a, b) => cmp(getName(b), getName(a)));
  return list.sort((a, b) => cmp(getName(a), getName(b)));
};

export const matchesQuery = (q, ...fields) => {
  const s = (q || "").trim().toLowerCase();
  return !s || fields.some((f) => String(f || "").toLowerCase().includes(s));
};
